import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/merchant_offer_discounts/:store_id?",
  component: function component() {
    return import("../../../views/merchant_offer_discounts/index.vue");
  },
  name: "merchant_offer_discounts",
  meta: {
    foot: true
  }
}];